import type { FC } from 'react';

import ServicesUserProfileView from 'components/UI/organisms/ServicesUserProfileView/ServicesUserProfileView';

const ServicesUserProfilePage: FC = () => <ServicesUserProfileView />;

export default ServicesUserProfilePage;
